module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.4373/img/callout-wave.svg"